/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React from "react";

import { renderErrorMsg } from "../../../assets/component/renderErrorMsg.js";
import RenderPaymentCode from "./RenderPaymentCode";
import ToggleSwitch from "../../../assets/component/ToggleSwitch/ToggleSwitch.js";
import { mapPaymentMethodDataStatus, mapPaymentMethodData } from "../../../assets/helper.js";
import UpgradeNoticeCard from "./UpgradeNoticeCard";

const paymentMethods = [
  {
    key: "alipay_hk",
    label: "AlipayHK (Hong Kong)",
  },
  {
    key: "alipay_ch",
    label: "Alipay (China)",
  }
];

export function RenderAlipay(state, func, textObj) {
  if (!state || !func) return;

  const alipayHKStatus = mapPaymentMethodDataStatus(state.organizationObj.paymentMethodCode, paymentMethods[0].key);
  const alipayHKData = mapPaymentMethodData(state.organizationObj.paymentMethodCode, paymentMethods[0].key);
  const alipayHKHasQRCode = Boolean(alipayHKData.code);

  const alipayCHStatus = mapPaymentMethodDataStatus(state.organizationObj.paymentMethodCode, paymentMethods[1].key);
  const alipayCHData = mapPaymentMethodData(state.organizationObj.paymentMethodCode, paymentMethods[1].key);
  const alipayCHHasQRCode = Boolean(alipayCHData.code);

  if (state.loading) {
    return (
      <div className="RenderAlipay-loading">
        <div className="RenderAlipay-spinner"></div>
      </div>
    );
  }

  const currentPlan = state.organizationObj.currentPlan
    ? state.organizationObj.currentPlan.toLowerCase()
    : "";
  const isPremiumPlan = currentPlan === "premium";

  return (
    <div className="RenderAlipay-contentContainer">
      <div className="RenderAlipay-content flex column">
        {isPremiumPlan ? (
          <>
            <div className="RenderAlipay-alipayContainer">
              {/* Payment Code */}
              <div className="RenderAlipay-alipayCodeContainer left">
                <div className="RenderAlipay-alipayHKLogo" />
                <div className="RenderAlipay-alipayText">Hong Kong</div>
                <RenderPaymentCode state={state} func={func} paymentMethod={paymentMethods[0]} />

                <div className="RenderAlipay-toggleContainer">
                  <ToggleSwitch
                    checked={alipayHKStatus.checked}
                    onChange={(e) => func.handleUpdatePaymentStatus(e, paymentMethods[0].key)}
                    disabled={!alipayHKHasQRCode}
                    disabledMessage={!alipayHKHasQRCode ? "Please upload a QR code first" : ""}
                  />
                </div>
              </div>

              <div className="RenderAlipay-alipayCodeContainer">
                <div className="RenderAlipay-alipayChinaLogo" />
                <div className="RenderAlipay-alipayText">China</div>
                <RenderPaymentCode state={state} func={func} paymentMethod={paymentMethods[1]} />

                <div className="RenderAlipay-toggleContainer">
                  <ToggleSwitch
                    checked={alipayCHStatus.checked}
                    onChange={(e) => func.handleUpdatePaymentStatus(e, paymentMethods[1].key)}
                    disabled={!alipayCHHasQRCode}
                    disabledMessage={!alipayCHHasQRCode ? "Please upload a QR code first" : ""}
                  />
                </div>
              </div>
              {/* END Payment Code */}
            </div>

            {renderErrorMsg(state.errMsgInfo.submitErr.msg)}

            <div className="RenderAlipay-footer" />
          </>
        ) : (
          <UpgradeNoticeCard onUpgradeClick={func.redirectToOrgBilling} />
        )}
      </div>
    </div>
  );
}
